module.exports = __webpack_public_path__ + "img/415.38e88241.jpg";